import React, { useEffect, useState } from "react";
import FilterForm from "./FilterForm";
import { Alert, Box, Typography } from "@mui/material";
import { useOdooInvoices } from "./provider";
import CustomTable from "../../ui/CustomTable";
import TabsList from "../../ui/TabsList";
import Status from "./Render/Status";
import { createYupSchema } from "../../utilities/yupSchemaCreator";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import Fields from "./Fields";
import { useNavigate, useParams } from "react-router-dom";
import Type from "./Render/Type";
import ActiveCell from "../Companies/CompanyTable/ActiveCell";
import { useAuth } from "../../services/auth";

const yupSchema = Fields.reduce(createYupSchema, {});
const formSchema = Yup.object().shape(yupSchema);

const List = () => {
  const { name } = useParams();
  const navigate = useNavigate();

  const [error, setError] = useState();
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [siteId, setSiteId] = useState();

  const {
    state: {
      list,
      page,
      perPage,
      count,
      length,
      journalEntriesList,
      countEntries,
      pageEntries,
      perPageEntries,
      lengthEntries,
      odooAccountsList,
      listOdooInvoicesReport,
    },
    dispatch,
    fetchList,
    fetchListOdooInvoicesReport,
    send,
    fetchJournalList,
    sendEntry,
    fetchOdooAccountsList,
    remove,
    SendAllInvoices,
  } = useOdooInvoices();
  const form = useForm({
    resolver: yupResolver(formSchema),
  });

  const { role } = useAuth();
  const tabConfig = {
    OdooInvoices: { title: "Odoo Invoices", num: length },
    OdooAccounts: {
      title: "Main Odoo",
      num: odooAccountsList?.filter((item) => item.locked).length,
    },
    OdooInvoicesReport: {
      title: "Odoo Invoices Report",
      num: listOdooInvoicesReport?.length,
    },
  };

  const defaultTab = { title: "Shift Odoo Journal Entry", num: lengthEntries };

  const tabs = [
    tabConfig[name] ?? defaultTab,
    ...(name === "OdooAccounts"
      ? [
          {
            title: "Expense Odoo",
            num: odooAccountsList?.filter((item) => !item.locked).length,
          },
        ]
      : []),
  ];
  const [selectedCols, setSelectedCols] = useState(
    name === "OdooInvoices"
      ? "Odoo Invoices"
      : name === "OdooAccounts"
        ? "Main Odoo"
        : "Shift Odoo Journal Entry",
  );

  const changePageSize = (size) => {
    if (name === "OdooInvoices" || name === "OdooInvoicesReport") {
      dispatch({ type: "set_per_page", payload: size });
    } else {
      dispatch({ type: "set_per_page_entries", payload: size });
    }
  };
  useEffect(() => {
    if (role === "Admin") fetchOdooAccountsList(0);
  }, [role]);
  const getList = () => {
    var displayList = new Array([]);
    switch (name) {
      case "OdooInvoices":
        displayList = list;
        break;
      case "ShiftOdooJournalEntry":
        displayList = journalEntriesList;
        break;
      case "OdooAccounts":
        selectedCols === "Main Odoo"
          ? (displayList = odooAccountsList?.filter((item) => item.locked))
          : (displayList = odooAccountsList?.filter((item) => !item.locked));
        break;
      case "OdooInvoicesReport":
        displayList = listOdooInvoicesReport;
        break;
      default:
        displayList = [];
    }
    return displayList;
  };
  const getCols = () => {
    var Cols = new Array([]);
    switch (name) {
      case "OdooInvoices":
        Cols = [
          {
            label: "Remark",
            name: "remark",
            headTextLeft: true,
            textLeft: true,
          },
          {
            label: "Partner",
            name: "partner_ref",
          },
          {
            label: "Date",
            name: "date",
          },
          {
            label: "Product",
            name: "product",
          },
          // {
          //   label: "Quantity",
          //   name: "quantity",
          // },
          {
            label: "Price Unit",
            name: "price_unit",
          },
          {
            label: "Quantity",
            name: "quantity",
          },
          {
            label: "Discount",
            name: "discount",
          },
          {
            label: "Status",
            name: "statusId",
            customRender: Status,
          },
        ];
        break;
      case "ShiftOdooJournalEntry":
        Cols = [
          { name: "siteShiftId", label: "Site Shift Id" },
          {
            name: "siteId",
            label: "Site Id",
          },
          {
            name: "siteName",
            label: "Site Name",
          },
          {
            name: "shiftDate",
            label: "Shift Date",
          },
          {
            name: "times",
            label: "Times",
          },
          {
            name: "lastRequestDate",
            label: "Last Request Date",
          },
          {
            name: "statusId",
            label: "Status",
            customRender: Status,
          },
        ];
        break;
      case "OdooAccounts":
        Cols = [
          { name: "number", label: "Number" },
          { name: "title", label: "Title" },
          { name: "type", label: "Type", customRender: Type },
          { name: "isActive", label: "Status", customRender: ActiveCell },
        ];
        break;
      case "OdooInvoicesReport":
        Cols = [
          { name: "siteId", label: "Site Id" },
          { name: "siteName", label: "Site Name" },
          { name: "success", label: "Success" },
          { name: "failure", label: "Failure" },
        ];
        break;
      default:
        Cols = [];
    }
    return Cols;
  };

  useEffect(() => {
    if (name === "OdooInvoices" && form.getValues("siteId") > 0)
      fetchList(form.getValues(), page, perPage);
  }, [name, page, perPage, form]);

  useEffect(() => {
    if (name === "OdooInvoicesReport")
      fetchListOdooInvoicesReport(form.getValues(), page, perPage);
  }, [name, page, perPage, form]);

  useEffect(() => {
    if (form.getValues("siteId") > 0 && form.getValues("companyId"))
      fetchJournalList(form.getValues(), page, perPage);
  }, [page, perPage, form]);

  const handleDelete = (id) => {
    try {
      remove(id);
    } catch (error) {
      setError({ title: error.errors.message });
      console.error(error, "error");
    }
  };

  const handleSendAllClick = async () => {
    try {
      if (form.getValues("siteId"))
        await SendAllInvoices(form.getValues("siteId"));
    } catch (error) {
      setError({ title: error.errors.message });
    }
  };

  return (
    <div>
      {name !== "OdooAccounts" ? (
        <>
          {" "}
          <Typography variant="Poster" component="h4" mb={2}>
            Select Site
          </Typography>{" "}
          <FilterForm
            form={form}
            formSubmitted={formSubmitted}
            setFormSubmitted={setFormSubmitted}
            siteId={siteId}
            setSiteId={setSiteId}
          />{" "}
        </>
      ) : null}

      <TabsList
        tabs={tabs}
        setSelectedCols={setSelectedCols}
        selectedCols={selectedCols}
      />
      <Box mb={1}>
        {error && (
          <Alert severity="error" sx={{ width: "fit-content" }}>
            {error}
          </Alert>
        )}
      </Box>
      <CustomTable
        empty={getList()?.length === 0 ? true : false}
        cols={getCols()}
        data={getList() || []}
        filters={{
          SendAllInvoices:
            name === "OdooInvoices" &&
            list.length !== 0 &&
            form.getValues("isFailure") &&
            formSubmitted
              ? handleSendAllClick
              : undefined,
          pagination: name !== "OdooAccounts" ? true : false,
          page: name === "OdooAccounts" ? perPageEntries : perPage,
          changePageSize: changePageSize,
          add:
            name === "OdooAccounts" && selectedCols === "Main Odoo"
              ? () => navigate(`/odoo/OdooAccounts/add/main`)
              : name === "OdooAccounts" && selectedCols === "Expense Odoo"
                ? () => navigate(`/odoo/OdooAccounts/add/expense`)
                : undefined,
        }}
        actions={
          name !== "OdooAccounts"
            ? {
                ...(name !== "OdooInvoicesReport"
                  ? {
                      reSend: async (id) => {
                        try {
                          if (name === "OdooInvoices") {
                            await send(id);
                          } else {
                            await sendEntry(id);
                          }
                        } catch (e) {
                          setError(e.errors.message);
                        }
                      },
                    }
                  : {
                      odooInvoicesReportAction: async (row) => {
                        try {
                          await SendAllInvoices(row?.siteId, {
                            fromDate: form.getValues("fromDate"),
                            toDate: form.getValues("toDate"),
                          });
                        } catch (error) {
                          setError(error.errors.message);
                        }
                      },
                      showMoreInvoices: (row) => {
                        form.setValue("siteId", row?.siteId);
                        setSiteId(row?.siteId);
                      },
                    }),
              }
            : {
                edit: (id, row) => {
                  dispatch({ type: "set_selectedAccount", payload: row });
                  if (selectedCols === "Main Odoo") {
                    navigate(`/Odoo/OdooAccounts/edit/${id}/main`);
                  } else if (selectedCols === "Expense Odoo") {
                    navigate(`/Odoo/OdooAccounts/edit/${id}/expense`);
                  }
                },
                delete: selectedCols === "Expense Odoo" && handleDelete,
              }
        }
        rowsPerPage={10}
        dispatch={dispatch}
        count={name === "OdooAccounts" ? countEntries : count}
        page={name === "OdooAccounts" ? pageEntries : page}
        isPagination={name !== "OdooAccounts" ? true : false}></CustomTable>
    </div>
  );
};

export default List;
